import styles from './Sentence.module.scss';

type Props = {
  phrase?: string;
};

const Sentence = (props: Props): JSX.Element => {
  const { phrase } = props;
  return (
    <div className={styles.sentence}>
      {phrase && <div dangerouslySetInnerHTML={{ __html: phrase }} />}
    </div>
  );
};
export default Sentence;
